import { render } from "./KapitelfragenQuizPage.vue?vue&type=template&id=5ec0fc10"
import script from "./KapitelfragenQuizPage.vue?vue&type=script&lang=js"
export * from "./KapitelfragenQuizPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__